import { FETCH_SYNDICATES_SUCCESS } from 'constants/syndicate';

const mySyndicates = (state = [], action) => {
  switch (action.type) {
    case FETCH_SYNDICATES_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

export default mySyndicates;



// WEBPACK FOOTER //
// ./src/reducers/mySyndicates.js